"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanionAddedEventArgs = void 0;
const EventType_1 = require("../EventType");
class CompanionAddedEventArgs {
    constructor(companionId) {
        this.companionId = companionId;
        this.__type = EventType_1.EventType.CompanionAdded;
        this.__typeName = "CompanionAdded";
    }
}
exports.CompanionAddedEventArgs = CompanionAddedEventArgs;
